import Brands from './containers/BrandsContainer';

export default Brands;
